import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import Levels from "./Levels";
const defaultAutos = {
    Branches: [],
};

export default function LevelsCon() {

  const tb = {
    wait: true,
    Branch: true,
    Levels:true,
    stor: { ...sto, branchi: sto.branchi  },
    parms:{
      iempid: sto.empi,
      tname: "level",
      branch:  sto.branchi,
      db_name:sto?.db_name,
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches 
  )
    return <LoadingPage />;

  return (
    <Levels
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
      }}
    />
  );
}
